export default [{
  title: '首页概况',
  name: 'home',
  permissionUrl: 'Index',
  path: '/home'
}, {
  title: '基础养老',
  permissionUrl: 'BasePensionManage',
  name: 'basePensionManage',
  path: '/basePension',
  submenu: [{
    title: '居家养老',
    permissionUrl: 'FamilyPensionManage',
    name: 'familyPensionManage',
    path: '/familyPensionManage'
  }, {
    title: '服务类型',
    permissionUrl: 'ServerTypeManage',
    name: 'ServerTypeManage',
    path: '/serverTypeManage'
  }, {
    title: '服务产品',
    permissionUrl: 'ServerProductManage',
    name: 'ServerProductManage',
    path: '/serverProductManage'
  }, {
    title: '机构养老',
    permissionUrl: 'OrgCenter',
    name: 'OrgCenter',
    path: '/orgCenter',
    submenu: [{
      title: '机构管理',
      permissionUrl: 'OrgManage',
      name: 'OrgManage',
      path: '/orgManage'
    }, {
      title: '人员管理',
      permissionUrl: 'StaffManage',
      name: 'StaffManage',
      path: '/staffManage'
    }, {
      title: '机构人员GIS',
      permissionUrl: 'OrgStaffMap',
      name: 'OrgStaffMap',
      path: '/orgStaffMap'
  },{
      title: '养老数据',
      permissionUrl: 'oldDataManage',
      name: 'oldDataManage',
      path: '/oldDataManage'
  }]
  }
  ]
}, {
  title: '康养横山',
  permissionUrl: 'KangYangHengShan',
  name: 'KangYangHengShan',
  path: '/kangYangHengShan',
  submenu: [
    {
      title: '天气管理',
      permissionUrl: 'WeatherManage',
      name: 'weatherManage',
      path: '/weatherManage'
    },
    {
      title: '资讯管理',
      permissionUrl: 'NewsManage',
      name: 'consultation',
      path: '/consultation'
    },
    {
      title: '楼盘管理',
      name: 'HouseManage',
      permissionUrl: 'HouseManage',
      path: '/houseManage'
    },
    {
      title: '康养小镇',
      name: 'Town',
      permissionUrl: 'Town',
      path: '/town'
    },
  ]
},{
  title: '旅居康养',
  permissionUrl: 'TourManage',
  name: 'TourManage',
  path: '/TourManage',
  submenu: [{
    title: '旅居人员',
    permissionUrl: 'TourElderManage',
    name: 'tourManage',
    path: '/tourManage'
  }, {
    title: '酒店管理',
    permissionUrl: 'HotelManage',
    name: 'hotelManage',
    path: '/hotelManage'
  }, {
    title: '景点管理',
    permissionUrl: 'SpotManage',
    name: 'scenicAreaManage',
    path: '/scenicAreaManage'
  }, {
    title: '门票管理',
    permissionUrl: 'TicketManage',
    name: 'ticketManage',
    path: '/ticketManage'
  }, {
    title: '酒店房间管理',
    permissionUrl: 'BedManage',
    name: 'bedManage',
    path: '/bedManage'
  }, {
    title: '活动管理',
    permissionUrl: 'TourActivityManage',
    name: 'TourActivityManage',
    path: '/TourActivityManage'
  }]
}, {
  title: '国医康养',
  permissionUrl: 'MedicalManage',
  name: 'MedicalManage',
  path: '/MedicalManage',
  submenu: [{
    title: '医疗设备管理',
    permissionUrl: 'MedicalEquipmentManage',
    name: 'MedicalEquipmentManage',
    path: '/MedicalEquipmentManage'
  }, {
  //   title: '服务产品管理（废弃）',
  //   permissionUrl: 'ServerEquipmentManage',
  //   name: 'ServerEquipmentManage',
  //   path: '/ServerEquipmentManage'
  // },{

    title: '健康智能产品',
    permissionUrl: 'IntellectEquipmentManage',
    name: 'IntellectEquipmentManage',
    path: '/IntellectEquipmentManage'
  }, {
    title: '设备类型管理',
    permissionUrl: 'EquipmentTypeManage',
    name: 'EquipmentTypeManage',
    path: '/equipmentTypeManage'
  }, {
    title: '特色诊疗项目',
    permissionUrl: 'MedicalProjectManage',
    name: 'medicalProjectManage',
    path: '/medicalProjectManage'
  }, {
    title: '相关案例管理',
    permissionUrl: 'MedicalCaseManage',
    name: 'MedicalCaseManage',
    path: '/MedicalCaseManage'
  }, {
    title: '国医简介',
    permissionUrl: 'IntroduceMedicineManage',
    name: 'IntroduceMedicineManage',
    path: '/IntroduceMedicineManage'
  }]
}, {
  title: '运动康养',
  permissionUrl: 'SportManage',
  name: 'SportManage',
  path: '/SportManage',
  submenu: [{
    title: '活动安排',
    permissionUrl: 'SportActivityManage',
    name: 'SportActivityManage',
    path: '/SportActivityManage'
  }, {
    title: '运动设备',
    permissionUrl: 'SportEquipmentManage',
    name: 'SportEquipmentManage',
    path: '/SportEquipmentManage'
  }, {
    title: '场地介绍',
    permissionUrl: 'IntroduceSiteManage',
    name: 'IntroduceSiteManage',
    path: '/IntroduceSiteManage'
  }]
}, {
  title: '扶贫康养',
  permissionUrl: 'AgriManage',
  name: 'AgriManage',
  path: '/AgriManage',
  submenu: [{
    title: '农户管理',
    permissionUrl: 'FarmerManage',
    name: 'FarmerManage',
    path: '/farmerManage'
  }, {
    title: '农产品类型',
    permissionUrl: 'ProduceTypeManage',
    name: 'ProduceTypeManage',
    path: '/ProduceTypeManage'
  }, {
    title: '特色产品',
    permissionUrl: 'ProduceManage',
    name: 'ProduceManage',
    path: '/ProduceManage'
  },{
    title: '特色餐饮',
    permissionUrl: 'RestudentManage',
    name: 'RestudentManage',
    path: '/RestudentManage'
  },{
    title: '康养服务人员',
    permissionUrl: 'serviceStaff',
    name: 'serviceStaff',
    path: '/serviceStaff'
  },{
    title: '志愿者',
    permissionUrl: 'postulant',
    name: 'postulant',
    path: '/postulant'
  },{
    title: '产品预约',
    permissionUrl: 'appointment',
    name: 'appointment',
    path: '/appointment'
  }]
}, {
  title: '物美康养',
  permissionUrl: 'ObjBeatifulManage',
  name: 'objBeatifulManage',
  path: '/objBeatifulManage',
}, {
  title: '消息管理',
  name: 'MessageManage',
  permissionUrl: 'MessageManage',
  path: '/messageManage'
},
{
  title: '队伍建设',
  permissionUrl: 'GroupAppraisalManage',
  name: 'GroupAppraisalManage',
  path: '/GroupAppraisalManage',
  submenu: [
    {
      title: '培训管理',
      permissionUrl: 'TrainManage',
      name: 'TrainManage',
      path: '/TrainManage'
    }, {
      title: '评价监督',
      permissionUrl: 'AppraisalManage',
      name: 'AppraisalManage',
      path: '/AppraisalManage'
    }, {
      title: '评论管理',
      permissionUrl: 'CommentManage',
      name: 'commentManage',
      path: '/commentManage'
    },
    {
      title: '人员评论',
      permissionUrl: 'commentPeople',
      name: 'commentPeople',
      path: '/commentPeople'
    },
    {
      title: '服务监督',
      permissionUrl: 'ServiceSupervision',
      name: 'ServiceSupervision',
      path: '/ServiceSupervision',
      submenu: [
        {
          title: '服务投诉',
          permissionUrl: 'ServiceComplaints',
          name: 'ServiceComplaints',
          path: '/serviceComplaints/1'
        },
        {
          title: '服务处理',
          permissionUrl: 'ServiceProcessing',
          name: 'ServiceProcessing',
          path: '/serviceComplaints/2'
        },
        {
          title: '服务回访',
          permissionUrl: 'ServiceReturnVisit',
          name: 'ServiceReturnVisit',
          path: '/serviceComplaints/3'
        },
      ]
    }
  ]
},
{
  title: '系统设置',
  permissionUrl: 'UserCenter',
  name: 'UserCenter',
  path: '/UserCenter',
  submenu: [{
    title: '用户管理',
    permissionUrl: 'AdminManage',
    name: 'AdminManage',
    path: '/AdminManage'
  },
  {
    title: '用户管理（单点）',
    permissionUrl: 'AdminManageVolunteer',
    name: 'AdminManageVolunteer',
    path: '/AdminManageVolunteer'
  },
  {
    title: '角色管理',
    permissionUrl: 'RoleManage',
    name: 'RoleManage',
    path: '/RoleManage'
  }, {
    title: '权限管理',
    permissionUrl: 'PermissionManage',
    name: 'permissionManage',
    path: '/permissionManage'
  }, {
    title: '模块管理',
    permissionUrl: 'MoudleManage',
    name: 'settingModule',
    path: '/settingModule'
  }, {
    title: '字典配置',
    permissionUrl: 'DictionaryConfig',
    name: 'dictionaryConfig',
    path: '/dictionaryConfig'
  },
    ]
},{
    title: '横山大屏',
    permissionUrl: 'screenHenSan',
    name: 'screenHenSan',
    path: '/screenHenSan',}

]



// WEBPACK FOOTER //
// ./src/config/routerConfig.js